import { IAllSettings } from '@models/service/all-settings.model';
import { IOtherSetting, IFacilitySetting } from '../../models/service/other-settings.model';

export class AddOtherSettings {
    static readonly type = '[Settings] AddOtherSettings]';
    constructor(public readonly payload: IOtherSetting[]) {}
}

export class AddFacilitySetting {
    static readonly type = '[Settings] AddFacilitySetting]';
    constructor(public readonly payload: IFacilitySetting) {}
}

export class AddAllSettings {
    static readonly type = '[Settings] AddAllSettings]';
    constructor(public readonly payload: IAllSettings) {}
}